export const types = {
  init: 'home/init',
};

// initial state
const state = {
  bgcolor: null,
  fixed: true,
  vimeoId: null,
  vimeoIdL: null,
  videoEnabled: false,
  image: {
    alt: null,
    focalPointX: null,
    focalPointY: null,
    src: {
      xs: null,
      s: null,
      m: null,
      900: null,
      l: null,
      xl: null,
      xxl: null,
      xxxl: null,
    },
  },
};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
